import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

const QUERY_PARAMS_TO_APPLY_AFTER_AUTH = {
  // NOTE: null => remove
  code: null,
  state: null,
}

export const cleanUpUrlAfterAuth = store.effects.create(
  (feature: Feature, router: router.Router) =>
    feature.actions.authenticate.success.observe().pipe(
      rxjs.map(() =>
        router.actions.navigate.from('cleanUpUrlAfterAuth (effect)').create({
          onSameUrlNavigation: 'ignore',
          queryParams: { plain: QUERY_PARAMS_TO_APPLY_AFTER_AUTH },
          replaceUrl: true,
        }),
      ),
    ),
)
